import { useState, useEffect } from "react";
import Axios from "axios";
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid'
import { PlusIcon, PencilSquareIcon } from '@heroicons/react/24/outline'
import ViewTemplateTable from "../../component/viewTempComp/viewTempComp";
import { useParams } from "react-router-dom";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import QuickAddDocModal from "../../component/QuickAddDocModal/QuickAddDocModal"; // Import new modal


export default function ViewTemplate() {

  const backEndUrl = process.env.REACT_APP_SERVER_ADDRESS

    const [data, setData] = useState();
    const [templateName, setTemplateName] = useState();
    const [templateFixedName, setTemplateFixedName] = useState();
    const [templateId, setTemplateId] = useState(useParams().id);

    const [open, setOpen] = React.useState(false);

    const [newDocName, setNewDocName] = React.useState('');
    const [newDocDescription, setNewDocDescription] = React.useState('');

    // 🟢 HELPER: Safely extracts the localized string (Copied from TemplateTable)
    const getLocalizedValue = (rawField, userData) => {
      // Get language from fetched user data, defaulting to english
      const userLang = userData?.preferredLanguage || 'english'; 
      
      if (!rawField) return '';
      if (typeof rawField === 'string') return rawField;
      
      // Case B: Multilingual object check
      if (rawField && typeof rawField === 'object') {
          if (userLang === 'french') {
              return rawField.fr || rawField.en || ''; 
          } else {
              return rawField.en || '';
          }
      }
      return ''; // Always return a string
    };


    const handleClickOpen = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    };


    const [openName, setOpenName] = React.useState(false);

    const handleClickOpenName = () => {
      setOpenName(true);
    };
  
    const handleCloseName = () => {
      setOpenName(false);
    };


    const addDocument = async (name, description) => {
         
         try {
            await Axios({
                method: 'POST',
                withCredentials: true,
                data: {
                    template_id: templateId,
                    document_name: name,
                    document_description: description,
                },
                url: `${backEndUrl}/updateClient/addDocToTemplate`,
            });
            
            window.location.reload();
        } catch (error) {
            
    
         }
    }

    const changeTemplateName = async (e) => {
      //  e.preventDefault();
       
     try {
        await Axios({
            method: 'PUT',
            withCredentials: true,
            data: {
                template_id: templateId,
                template_name: templateName,
            },
            url: `${backEndUrl}/updateClient/updateTemplateName`,
        });
        
        window.location.reload();
    } catch (error) {
        

     }
    }

    useEffect(() => {
        Axios ({
           method: "GET",
          withCredentials: true,
            url: `${backEndUrl}/auth/consultantLog`,
     
         
          }).then((res) => {
           setData(res.data);       
          });
     }, []) 

 

     // loop through the data to get the template name

    useEffect(() => {
      // 🟢 CRITICAL FIX: Localize the name before setting state
      if (data !== undefined && data.docTemplates) {
        for (let i = 0; i < data.docTemplates.length; i++) {
          if (data.docTemplates[i]._id === templateId) {
            // Get the raw name (object or string)
            const rawName = data.docTemplates[i].name;
            // Set the state with the localized STRING version
            setTemplateFixedName(getLocalizedValue(rawName, data));
            break; // Exit loop once template name is found
          }
        }
      }
    }, [data, templateId]);

     if (data === undefined) {

        return (<>Still loading...</>)
    }
    
    else {

    return (
        <div className="px-10 pb-10">

 

   



    <div>
      <div className="mt-8" >
        <nav aria-label="Back" className="sm:hidden">
          <span className="flex items-center text-sm font-medium text-gray-500 cursor-default select-none">
            <ChevronLeftIcon aria-hidden="true" className="-ml-1 mr-1 h-5 w-5 shrink-0 text-gray-400" />
            Back
          </span>
        </nav>
        <nav aria-label="Breadcrumb" className="hidden sm:flex">
          <ol role="list" className="flex items-center space-x-4">
            <li>
              <div className="flex">
                <span className="text-sm font-medium text-gray-500 cursor-default select-none">
                  List
                </span>
              </div>
            </li>
            <li>
              <div className="flex items-center">
                <ChevronRightIcon aria-hidden="true" className="h-5 w-5 shrink-0 text-gray-400" />
                <span className="ml-4 text-sm font-medium text-gray-500 cursor-default select-none">
                  Templates
                </span>
              </div>
            </li>
            <li>
              <div className="flex items-center">
                <ChevronRightIcon aria-hidden="true" className="h-5 w-5 shrink-0 text-gray-400" />
                <span aria-current="page" className="ml-4 text-sm font-medium text-gray-500 cursor-default select-none">
                {templateFixedName}
                </span>
              </div>
            </li>
          </ol>
        </nav>
      </div>
      <div className="mt-6 md:flex md:items-center md:justify-between">
        <div className="min-w-0 flex-1">
          <h2 className="text-2xl/7 mt-2 font-bold text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
            {templateFixedName}
          </h2>
        </div>
        <div className="mt-4 flex shrink-0 md:ml-4 md:mt-0 gap-3">
          <button
            type="button"
            className="inline-flex items-center gap-2 bg-white  border-slate-300 text-slate-700 px-4 py-2 rounded-lg text-sm font-semibold shadow-sm hover:bg-slate-50 transition-all"
            onClick={handleClickOpen}
          >
            <PencilSquareIcon className="h-4 w-4" />
            Rename
          </button>
          <button
            type="button"
            className="inline-flex items-center gap-2 bg-[#0a79be] hover:bg-[#0052CC] text-white px-4 py-2 rounded-lg text-sm font-semibold shadow-sm hover:shadow transition-all mr-8"
            onClick={handleClickOpenName}
          >
            <PlusIcon className="h-4 w-4" />
            Add document
          </button>
        </div>
      </div>
    </div>



   <ViewTemplateTable
              clients={data.docTemplates}
      
           
        />  
  
        

        <React.Fragment>
   
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: 'form',
          onSubmit: (event) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries(formData.entries());
            const email = formJson.email;
            
            handleClose();
          },
        }}
      >
        <DialogTitle>
        Rename Your Template</DialogTitle>
        <DialogContent>
          <DialogContentText>
          Please enter the new name for your template.
          </DialogContentText>
          <TextField
            autoFocus
            required
            margin="dense"
            id="name"
            name="email"
            label="Template name"
            type="text"
            fullWidth
            variant="standard"
            onChange={(e) => setTemplateName(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' onClick={handleClose}>Cancel</Button>
          <Button variant='contained' onClick={changeTemplateName}>Confirm</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>

    <React.Fragment>

      <QuickAddDocModal
        isOpen={openName}
        onClose={handleCloseName}
        onSubmit={addDocument}
      />
    </React.Fragment>
      
        </div>
    )
}
}
